import Button from 'components/Button/index'
import Flex from 'components/Flex'
import React from 'react'
import { ShortlistDiv, StyledModal, UploadMsgFlex } from './style'

const SuccessModal = ({
  description,
  Icon,
  showDrawer,
  setShowDrawer,
  onCloseClick,
  onTemporaryCloseClick = () => {},
  loading,
  handleCloseDrawer = () => {},
}) => {
  const onClose = () => {
    onTemporaryCloseClick()
    setShowDrawer(false)
    handleCloseDrawer()
  }

  return (
    <div>
      <StyledModal
        open={showDrawer}
        centered
        footer={''}
        width={700}
        maskClosable={false}
        closable={false}
        bodyStyle={{
          borderRadius: '20px',
          padding: '20px',
          textAlign: 'center',
          height: '434px',
          width: '650px',
        }}
      >
        <UploadMsgFlex column center centerVertically>
          <Icon></Icon>
          <ShortlistDiv>
            {description}
          </ShortlistDiv>
          <Flex style={{ gap: '1em !important' }}>
            <Button.Secondary
              text="Close"
              width="64px"
              height="38px"
              onClick={onClose}
            />
          </Flex>
        </UploadMsgFlex>
      </StyledModal>
    </div>
  )
}

export default SuccessModal
